import {ChangeDetectorRef, Component, ApplicationRef} from '@angular/core';
import {FuseMediaWatcherService} from "../@fuse/services/media-watcher";
import {FlowFeedbackService} from "@store/flow-feedback/flow-feedback.service";
import {LangsListParamsService} from "@store/langs-list-params.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  /**
   * Constructor
   */
  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private appRef: ApplicationRef,
    public langsListParamsService: LangsListParamsService,
  ) {

    this._fuseMediaWatcherService.onMediaChange$.subscribe((data) => {
      setTimeout(() => {
        this.appRef.tick();
      }, 500);
    })
  }
}
